import { d as o, _ as s } from "./_plugin-vue_export-helper-8568c831.mjs";
import { openBlock as t, createElementBlock as r, normalizeClass as n, normalizeStyle as l, createElementVNode as c } from "vue";
const a = o("search"), i = /* @__PURE__ */ c("path", {
  d: "M512 1024C231.131 1024 0 792.869 0 512S231.131 0 512 0s512 231.131 512 512-231.131 512-512 512zm0-936.229C277.943 87.771 87.771 277.943 87.771 512S277.943 936.229 512 936.229 936.229 746.057 936.229 512 746.057 87.771 512 87.771zM980.114 1024c-11.703 0-23.405-2.926-32.183-11.703L830.903 895.27c-17.554-17.555-17.554-43.886 0-61.44s43.886-17.555 61.44 0l117.028 117.028c17.555 17.554 17.555 43.886 0 61.44-5.851 8.777-17.554 11.703-29.257 11.703z",
  fill: "currentColor",
  "fill-opacity": "0.9"
}, null, -1), p = [
  i
];
function m(e, _, d, f, h, u) {
  return t(), r("svg", {
    class: n(e.classes),
    style: l(e.style),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    role: "presentation"
  }, p, 6);
}
const C = /* @__PURE__ */ s(a, [["render", m]]);
export {
  C as default
};
